import * as React from "react";
import type { SVGProps } from "react";
const SvgPlaneEarth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#plane-earth_svg__a)">
      <path d="M11 22a10 10 0 1 1 10-10 1 1 0 0 1-2 0 8 8 0 1 0-8 8 1 1 0 0 1 0 2" />
      <path d="M19.4 10H2.6a1 1 0 1 1 0-2h16.8a1 1 0 0 1 0 2M11 16H2.6a1 1 0 0 1 0-2H11a1 1 0 0 1 0 2" />
      <path d="M10.58 22a1 1 0 0 1-.85-.47 17.92 17.92 0 0 1-.09-18.92 1 1 0 0 1 1.71 1.04 15.91 15.91 0 0 0 .08 16.82 1 1 0 0 1-.85 1.53" />
      <path d="M14 13a1 1 0 0 1-1-1 16 16 0 0 0-2.31-8.4 1 1 0 0 1 .697-1.517 1 1 0 0 1 1.013.467A18 18 0 0 1 15 12a1 1 0 0 1-1 1M18.24 16.09l2.16-1.25a1.26 1.26 0 0 1 1.71.46 1.25 1.25 0 0 1-.46 1.7l-7.56 4.36-1.87-1.66a1 1 0 0 1 .17-1.67 1 1 0 0 1 .79-.11l1.29.35 1.08-.62-2.33-2.25a1 1 0 0 1 .19-1.56 1 1 0 0 1 1 0z" />
    </g>
    <defs>
      <clipPath id="plane-earth_svg__a">
        <path fill="#fff" d="M1 2h21.27v20H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlaneEarth;
